export const durationToSecond = (duration: number) => {
  const totalSeconds = Math.ceil(duration / 1000); // 少于1s向上取整
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  // 在小时、分钟和秒钟上添加前导零（如果需要）
  const hoursString = hours ? hours.toString().padStart(2, '0') : '';
  const minutesString = minutes.toString().padStart(2, '0');
  const secondsString = seconds.toString().padStart(2, '0');

  return [hoursString, minutesString, secondsString].filter(Boolean).join(':');
};
